import axios from 'axios';
import pageMain from './layout/pageMain.vue';

const install = function (Vue) {

    let layouts = {
        pageMain: pageMain,
    };

    Object.keys(layouts).forEach(key => Vue.component(key, layouts[key]));
}

const master = function (config) {
    return {
        ...config,
        data: function () {
            return {
                query: { ...config['query'] },
                tableData: { count: 0, value: [] },
                pager: {},
                allSelected: false,
                deleteItem: [],
                modalkey: undefined,
                ...config['data']
            }
        },
        created: function () {
            Object.keys(this.$route.query).forEach(key => this.query[key] = this.$route.query[key]);
            this.$parameter.sdate()
                .then(res => {
                    this.query.syear = this.query.syear || res.data.Syear;
                    this.query.semester = this.query.semester || res.data.Semester;
                })
                .finally(() => {
                    this.load();
                    if (config['created']) { config['created'].call(this); }
                });
        },
        computed: {
            selectall: {
                set: function (value) {
                    let chks = document.getElementsByClassName("del");
                    for (var i = 0; i < chks.length; i++) {
                        let index = this.deleteItem.findIndex(function (x) { return x == chks[i].value });
                        if (value) {
                            if (index == -1) {
                                this.deleteItem.push(chks[i].value);
                            }
                        } else {
                            if (index != -1) {
                                this.deleteItem.splice(index, 1);
                            }
                        }
                    }
                    this.allSelected = value;
                },
                get: function () {
                    return this.allSelected;
                }
            }
        },
        methods: {
            load: function () {
                return this.$http({ method: 'get', url: config['api'] + "/Get", params: this.query, headers: this.pager })
                    .then(res => { this.tableData = res.data || { count: 0, value: [] } });
            },
            reload: function () {
                this.pager.skip = 0;
                return this.load();
            },
            insert: function () {
                this.modalkey = null;
                this.$bvModal.show('info');
            },
            edit: function (value) {
                this.modalkey = value;
                this.$bvModal.show('info');
            },
            del: function () {
                return this.$http({ method: 'delete', url: config['api'] + "/Delete", data: this.deleteItem })
                    .then(() => {
                        this.deleteItem = [];
                        this.load();
                    });
            },
            input: function () {
                this.$bvModal.show('input');
            },
            ...config['methods']
        }
    };
};

const detail = function (config) {
    return {
        ...config,
        props: ['id', 'modalkey'],
        data: function () {
            return {
                vm: { ...config['vm'] },
                loading: false, saveing: false,
                ...config['data']
            };
        },
        computed: {
            isedit: function () {
                return this.modalkey !== null;
            },
            ...config['computed']
        },
        methods: {
            ...config['methods'],
            shown: function () {
                if (this.modalkey) {
                    this.loading = true;
                    let transformResponse = [config['showntransform'] || ((data) => data), ...axios.defaults.transformResponse];
                    this.$http({ method: 'get', url: config['api'] + "/Get/" + this.modalkey, transformResponse })
                        .then(res => this.vm = res.data)
                        .finally(() => this.loading = false);
                } else {
                    this.vm = { ...config['vm'] };
                }
                if (config['shown']) { (config['shown']).call(this); }
            },
            save: function () {
                this.saveing = true;
                let transformRequest = [config['savetransform'] || ((data) => data), ...axios.defaults.transformRequest];
                let method = this.isedit ? 'post' : 'put';
                this.$http({ method: method, url: config['api'] + "/" + method, data: this.vm, transformRequest })
                    .then((res) => {
                        // todo: 待修繕
                        let message = '儲存成功';
                        if (this.$i18n.locale === 'en') {
                            message = 'save success';
                        }
                        this.$bvToast.toast(message, { title: '', variant: 'success', solid: true });
                        this.$emit('reload');
                        this.$emit('edit', res.data.modalkey);
                    })
                    .finally(() => {
                        this.saveing = false;
                        if (this.modalkey) {
                            this.shown();
                        }
                    });
            },
            cancel: function () {
                this.$bvModal.hide(this.id);
            },
        },
    };
};

export default { install };
export { master, detail };